import ErrorPage from '../pages/other/ErrorPage';
import LoginPage from '../pages/login/LoginPage';
import {env} from './env';
import {RouteType} from './routeType';

/**
 * Route to check page that are normally difficult to reach
 * @returns
 */
export function routeChecks(): RouteType<any>[] {
  if (!env.isDev) {
    return [];
  }
  return [
    {
      path: '/checkLogin',
      component: LoginPage,
    },
    {
      path: '/checkError',
      component: ErrorPage,
    },
  ];
}
